import styled from 'styled-components';

import { HAIRLINE_COLOR } from '../styles';

interface BadgeProps {
	$color: string;
	$background: string;
}

export const Logo = styled.img`
	display: block;
	width: 12.5rem;
	height: 3.9375rem;
	object-fit: contain;
`;

export const HeaderSubtitle = styled.span`
	display: block;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1.5rem;
	line-height: 2rem;
`;

export const HeaderTitle = styled.h2`
	margin: 0;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1.5rem;
	font-weight: 600;
	line-height: 2rem;
`;

export const InfoLine = styled.p`
	margin: 0;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1rem;
	line-height: 1.375rem;
`;

export const InfoLabel = styled.span`
	font-weight: 600;
`;

export const InfoColumns = styled.div`
	padding-left: 1rem;
`;

export const VerticalDivider = styled.div`
	width: 1px;
	height: 100%;
	min-height: 12.75rem;
	background: ${HAIRLINE_COLOR};
`;

export const ScoreLabel = styled.span`
	display: block;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1rem;
	font-weight: 600;
	line-height: 1.375rem;
`;

export const ScoreValue = styled.span`
	display: block;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1rem;
	line-height: 1.375rem;
`;

export const Badge = styled.span<BadgeProps>`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 5.875rem;
	height: 2.375rem;
	background: ${({ $background }) => $background};
	border: 1px solid ${({ $color }) => $color};
	border-radius: 0.25rem;
	color: ${({ $color }) => $color};
	font-size: 1rem;
	font-weight: 600;
	line-height: 1.5rem;
`;
